import { Inject } from 'inversify-props'
import type { RegraDeImpostoServiceAdapter } from '@/usecases'
import { CapaRegraImposto, Page, RegraDeEstado } from '@/models'
import { AxiosRequestConfig } from 'axios'

export class FindRegraDeImpostoUseCase {
	@Inject('RegraDeImpostoServiceAdapter')
	private regraService!: RegraDeImpostoServiceAdapter

	async getRegra(id: string): Promise<CapaRegraImposto> {
		return this.regraService.get(id)
	}

	find = async (params?: any, config?: AxiosRequestConfig): Promise<Page<CapaRegraImposto>> =>
		await this.regraService.find(params, config)

	getItens = async (regraId: string, params?: any, config?: AxiosRequestConfig): Promise<Page<RegraDeEstado>> =>
		await this.regraService.getItens(regraId, params, config)

	ncmExistsByRegraImposto = async (ncmId: string, regraId: string): Promise<boolean> =>
		await this.regraService.ncmExistsByRegraImposto(ncmId, regraId)

	validarNovaRegraDeNcm = async (ncmId: string, tipoTransacao: string, entradaSaida: string, regime: string): Promise<boolean> =>
		await this.regraService.validarNovaRegraDeNcm(ncmId, tipoTransacao, entradaSaida, regime)
}
